export default __webpack_public_path__ + "static/media/e-operations.c066d80e.png";